import React from "react";
import "./NotFound.css";

const NotFound = () => {
	return (
		<div>
			<h1 className='title-head'>Page Not Avaliable</h1>
		</div>
	);
};

export default NotFound;
